UrgencyMessaging = window.UrgencyMessaging ?= {}

PRIMARY_MESSAGE_TIMEOUT = 5000
ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000
PRIMARY_MESSAGE_TIMEOUT_TOUCH = PRIMARY_MESSAGE_TIMEOUT - ACTIVATE_PRIMARY_MESSAGE_TIMEOUT
POPUP_SWITCH_MESSAGE_TIMEOUT = 500

UrgencyMessaging.inlineUrgencyMessaging = (touchRequest) ->
  urgencyMessages = $('.urgency-messaging.inline .urgency-message')
  primaryMessage = urgencyMessages.find('.primary')
  secondaryMessage = urgencyMessages.find('.secondary')

  switchMessage = ->
    primaryMessage.addClass('fade-out')
    secondaryMessage.children('span').removeClass('hide')
    secondaryMessage.addClass('fade-in')

  unless touchRequest
    urgencyMessages.addClass('visible')
    primaryMessage.addClass('fade-in')

  inlineSwitchMessageTimeout = if touchRequest then PRIMARY_MESSAGE_TIMEOUT_TOUCH else PRIMARY_MESSAGE_TIMEOUT
  if secondaryMessage.length
    window.setTimeout switchMessage, inlineSwitchMessageTimeout

UrgencyMessaging.popupUrgencyMessaging = ->
  urgencyMessages = $('.urgency-messaging.popup')
  primaryMessage = urgencyMessages.find('.primary')
  secondaryMessage = urgencyMessages.find('.secondary')
  isMessageSwitched = false

  addSecondaryMessage = ->
    secondaryMessage.addClass('pop-in')

  switchMessage = ->
    return if isMessageSwitched
    isMessageSwitched = true
    primaryMessage.addClass('pop-out')
    window.setTimeout addSecondaryMessage, POPUP_SWITCH_MESSAGE_TIMEOUT

  addXIconHandler = ->
    popup = $(this).parent('.ums-text')
    if popup.hasClass('primary')
      switchMessage()
    else
      popup.addClass('pop-out')

  urgencyMessages.find('.icon-x').click addXIconHandler

  primaryMessage.addClass('pop-in')

  if secondaryMessage.length
    setTimeout switchMessage, PRIMARY_MESSAGE_TIMEOUT

UrgencyMessaging.init = ({umsData}, done) ->
  {realTimeMessaging} = umsData
  {touchRequest, showPopups, inlineTreatment} = realTimeMessaging
  isActivated = false

  activateUrgencyMessaging = ->
    return if isActivated
    isActivated = true
    if inlineTreatment
      UrgencyMessaging.inlineUrgencyMessaging touchRequest
    else if showPopups
      UrgencyMessaging.popupUrgencyMessaging()

  scrollHandler = (e) ->
    if $(this).scrollTop() > 0
      $(this).off(e)
      activateUrgencyMessaging()

  $ ->
    window.setTimeout activateUrgencyMessaging, ACTIVATE_PRIMARY_MESSAGE_TIMEOUT

    $(window).on 'scroll', scrollHandler

    done()

module.exports = UrgencyMessaging
